import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const ThemeContext = createContext(null);

const DARK_MODE_KEY = "crm_dark_mode";
const LEGACY_MAIL_DARK_KEY = "crm_mail_dark_mode";

function readInitialDarkMode() {
    try {
        const stored = localStorage.getItem(DARK_MODE_KEY);
        if (stored !== null) return stored === "1";
        return localStorage.getItem(LEGACY_MAIL_DARK_KEY) === "1";
    } catch {
        return false;
    }
}

export function ThemeProvider({ children }) {
    const [darkMode, setDarkMode] = useState(readInitialDarkMode);
    const [sidebarHidden, setSidebarHidden] = useState(false);

    useEffect(() => {
        document.documentElement.classList.toggle("crm-dark-mode", darkMode);
        try {
            localStorage.setItem(DARK_MODE_KEY, darkMode ? "1" : "0");
            localStorage.setItem(LEGACY_MAIL_DARK_KEY, darkMode ? "1" : "0");
        } catch {
            /* ignore */
        }
    }, [darkMode]);

    const toggleDarkMode = useCallback(() => {
        setDarkMode((prev) => !prev);
    }, []);

    const hideSidebar = useCallback(() => {
        setSidebarHidden(true);
    }, []);

    const showSidebar = useCallback(() => {
        setSidebarHidden(false);
    }, []);

    const value = {
        darkMode,
        setDarkMode,
        toggleDarkMode,
        sidebarHidden,
        setSidebarHidden,
        hideSidebar,
        showSidebar,
    };

    return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx) {
        throw new Error("useTheme must be used within ThemeProvider");
    }
    return ctx;
}
